var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFacebook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M10 0c5.523 0 10 4.477 10 10 0 4.943-3.586 9.048-8.299 9.856L11.7 12.8h2.2l.45-2.8H11.7V8.05c0-.8.3-1.4 1.5-1.4h1.3V4.1c-.7-.1-1.5-.2-2.2-.2-2.3 0-3.9 1.4-3.9 3.9V10H5.9v2.8h2.5v7.073C3.638 19.107 0 14.978 0 10 0 4.477 4.477 0 10 0z"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMCIgaGVpZ2h0PSIyMCIgdmlld0JveD0iMCAwIDIwIDIwIj48cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xMCwwIEMxNS41MjI4NDc1LDAgMjAsNC40NzcxNTI1IDIwLDEwIEMyMCwxNC45NDI5NzEzIDE2LjQxMzY1NTgsMTkuMDQ4MzA3IDExLjcwMTA3MzEsMTkuODU1OTAxNyBMMTEuNywxMi44IEwxMy45LDEyLjggTDE0LjM1LDEwIEwxMS43LDEwIEwxMS43LDguMDUgQzExLjcsNy4yNSAxMiw2LjY1IDEzLjIsNi42NSBMMTQuNSw2LjY1IEwxNC41LDQuMSBDMTMuOCw0IDEzLDMuOSAxMi4zLDMuOSBDMTAsMy45IDguNCw1LjMgOC40LDcuOCBMOC40LDEwIEw1LjksMTAgTDUuOSwxMi44IEw4LjQsMTIuOCBMOC40MDAwMTA0MywxOS44NzI2OTAxIEMzLjYzNzcyNCwxOS4xMDY4NzA0IDAsMTQuOTc4MjUzMiAwLDEwIEMwLDQuNDc3MTUyNSA0LjQ3NzE1MjUsMCAxMCwwIFoiLz48L3N2Zz4=";
export { SvgFacebook as ReactComponent };